// @flow

import { exists } from '@zapier/common-utils';

const toString = (thing: mixed) => (exists(thing) ? String(thing) : '');

const toLowerCaseString = (thing: mixed): string =>
  toString(thing).toLowerCase();

export default toLowerCaseString;
